import React, { Fragment } from "react";
import DataTable, {  Row } from "../../DataTable.jsx";
import { MULTILOOP_MODULE_NAMES } from "../../const.js";
import { useHwaddrAndNetworkIdFromRouter, useModules } from "../../store/panelsSlice.js";


export const ModuleTabEntry = ({ module, children }) => (
    <DataTable>
        <Row label="Port">{ module.port_id }</Row>
        <Row label="Type">{ (module.port_type in MULTILOOP_MODULE_NAMES) ? MULTILOOP_MODULE_NAMES[module.port_type] : module.port_type }</Row>
        {
            module.devices.length > 0 
                ?
                ( <Row label="Sub-Devices">{ module.devices.length }</Row> )
                : 
                null
        }
        {children}
    </DataTable>
)




export const ModuleTab = (props) => {
    const modules = useHwaddrAndNetworkIdFromRouter(useModules);
    return <Fragment>
        {modules.map(
            mod => (<ModuleTabEntry 
                key={mod.port_id}
                module={mod}
            >
                <Row label="Edit"><a role="button" className="btn btn-primary" href={`#${props.match.url}/${mod.port_id}`}>Edit</a></Row>
                {/* <Row label="Debug">
                    <details>
                        <summary>Data</summary>
                        <pre>{JSON.stringify(mod, null, 2 )}</pre>
                    </details>
                </Row> */}
            </ModuleTabEntry>)
        )}
    </Fragment>
}



